import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink";
import { LearnMoreResources, TopicsContainer } from "../../CommonComponents/CommonViews";
export const ProjectVersionControlSettingsTopics = () => (<TopicsContainer>
        <LearnMoreResources>
            <div>
                <ExternalLink href="ConfigAsCodeConfiguration">Connecting projects to Git</ExternalLink>
            </div>
            <div>
                <ExternalLink href="ConfigAsCodeMoving">Moving version control</ExternalLink>
            </div>
            <div>
                <ExternalLink href="GitHubApp">GitHub App</ExternalLink>
            </div>
        </LearnMoreResources>
    </TopicsContainer>);
